module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/footer/footer.component.scss
// module id = ./src/app/theme/footer/footer.component.scss
// module chunks = main